export const PHONE_PATTERN = /^\D*(\d\D*){10}$/;
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const USA_ZIP_PATTERN = /^\d{5}(-\d{4})?$/;
export const CANADA_ZIP_PATTERN = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
export const NUMBER_RANGE_PATTERN = /^-?\d+(\.\d{1})?$/;
export const TANK_SIZE_PATTERN = /^(?:[1-9]|[1-9]\d{1,3}|[1-4]\d{4}|50000)$/;
export const CAPACITY_PATTERN = /,\s*\d{1,6}(?:,\d{3})?\s*Btu/g;
export const BTU_PER_HOUR = 'BTU/h';
export const BTU_SMALL = 'btu'
export const KW = 'kW';
export const KW_SMALL = 'kw';
export const GAL = 'gal';
export const LITERS = 'liters';
export const L = 'L';
export const ALERT = 'common.alert';
export const ENGLISH = 'English';
export const CREATE_PROJECT_TABS = {
  SETTINGS: 0,
  SELECTION: 1,
  SOLUTION: 2
};

export const PROJECT_STATUSES = ['status.inProgress', 'status.delivered'];

export const DATE_FILTERS = [
  { id: 'today', label: 'dateFilter.today' },
  { id: 'thisWeek', label: 'dateFilter.thisWeek' },
  { id: 'thisMonth', label: 'dateFilter.thisMonth' },
  { id: 'lastWeek', label: 'dateFilter.lastWeek' },
  { id: 'lastMonth', label: 'dateFilter.lastMonth' },
  { id: 'custom', label: 'dateFilter.custom' },
];

export const DATE_FILTER = {
  TODAY: 'today',
  THIS_WEEK: 'thisWeek',
  THIS_MONTH: 'thisMonth',
  LAST_WEEK: 'lastWeek',
  LAST_MONTH: 'lastMonth',
  CUSTOM: 'custom'
}

export const PROJECT = {
  NAME: 'name',
  STATUS: 'status',
  APPLICATION_TYPE: 'applicationType',
  CREATED_DATE: 'createdDate',
}

export const MAIN_STEPPER = [
  { label: 'editProject.settings', text: ' ', disabled: false },
  { label: 'editProject.selection', text: ' ', disabled: true },
  { label: 'editProject.solution', text: ' ', disabled: true },
];

export const PROJECT_TABS_URL = {
  SETTINGS: 'settings',
  SELECTION: 'selection',
  SOLUTION: 'solution',
}

export const DESIGN_SOLUTION_TEMPERATURE_FAHRENHEIT = {
  DBTCoolingMin: 68,
  DBTCoolingMax: 109.4,
  DBTHeatingMin: -13,
  DBTHeatingMax: 68,
  WBTHeatingMin: -148,
  WBTHeatingMax: 194
}

export const DESIGN_SOLUTION_TEMPERATURE_CELSIUS = {
  DBTCoolingMin: 20,
  DBTCoolingMax: 43,
  DBTHeatingMin: -25,
  DBTHeatingMax: 20,
  WBTHeatingMin: -100,
  WBTHeatingMax: 90
}

export const DESIGN_SOLUTION_STEPS = [
  {
    id: 1,
    label: 'designSolution.applicationType',
    disabled: false,
  },
  {
    id: 2,
    label: 'designSolution.constructionType',
    disabled: false,
  },
  {
    id: 3,
    label: 'designSolution.systemDesign',
    disabled: false,
  },
  {
    id: 4,
    label: 'designSolution.emitter',
    disabled: false,
  }
]

export const APPLICATION_TYPES = [
  {
    id: 5,
    label: 'applicationType.spaceHeatingOrCoolingAndHotWater',
    img1: 'sun-freeze',
    img2: 'shower',
    doubleImg: true,
  },
  {
    id: 3,
    label: 'applicationType.spaceHeatingAndHotWater',
    img1: 'hotsun',
    img2: 'shower',
    doubleImg: true,
  },
  {
    id: 4,
    label: 'applicationType.spaceHeatingOrCooling',
    img1: 'sun-freeze',
  },
  {
    id: 2,
    label: 'applicationType.spaceHeating',
    img1: 'hotsun',
    doubleImg: false,
  },
  {
    id: 1,
    label: 'applicationType.spaceCooling',
    img1: 'cooling',
    doubleImg: false,
  }
];

export const CONSTRUCTION_TYPES = [
  {
    label: 'constructionType.newConstruction',
    img: 'home',
    id: 1
  },
  {
    label: 'constructionType.addOn',
    img: 'add-on',
    id: 2
  }
];

export const SYSTEM_DESIGN_TYPES = [
  {
    id: '1',
    name: 'Hydro Split'
  },
  {
    id: '2',
    name: 'Monobloc'
  }
];

export const HYDRO_SPLIT_CAPACITIES_BTU = [
  {
    id: 1,
    label: 'UPRA036DAVK',
    nominalValue: 36000,
    value: 36000
  },
  {
    id: 2,
    label: 'UPRA043DAVK',
    nominalValue: 43000,
    value: 43000
  }
];

export const HYDRO_SPLIT_CAPACITIES_KW = [
  {
    id: 1,
    label: 'UPRA036DAVK',
    nominalValue: 10.55,
    value: 10.5505573918
  },
  {
    id: 2,
    label: 'UPRA043DAVK',
    nominalValue: 12.60,
    value: 12.6020546624
  }
];

export const YES_NO_OPTIONS = [
  {
    id: 1,
    label: 'options.yes',
    value: true
  },
  {
    id: 2,
    label: 'options.no',
    value: false
  }
];

export const CONNECTION_KITS = [
  {
    id: 1,
    label: 'UKHY3PART',
    value: 'UKHY3PART'
  }
];

export const TANK_SIZE_GAL = [
  {
    id: 1,
    name: 'UHWS40D3VJ',
    label: 40,
    value: 40
  },
  {
    id: 2,
    name: 'UHWS50D3VJ',
    label: 50,
    value: 50
  },
  {
    id: 3,
    name: 'UHWS80D3VJ',
    label: 80,
    value: 80
  }
];

export const TANK_SIZE_LITER = [
  {
    id: 1,
    name: 'UHWS40D3VJ',
    label: 150,
    value: 151.42
  },
  {
    id: 2,
    name: 'UHWS50D3VJ',
    label: 200,
    value: 189.27
  },
  {
    id: 3,
    name: 'UHWS80D3VJ',
    label: 300,
    value: 302.83
  }
];

export const EMITTER_TYPES = [
  {
    id: 0,
    name: 'emitterList.hydronicAirHandler',
    image: 'hydronic-air-handler'
  },
  {
    id: 1,
    name: 'emitterList.hpConvector',
    image: 'hp-convector',
    imageHp: 'floor-standing',
    imageWall: 'wall-mounted',
  },
  {
    id: 2,
    name: 'emitterList.radiantFloor',
    image: 'radiantfloor'
  },
  {
    id: 3,
    name: 'emitterList.baseboardRadiator',
    image: 'baseboard',
  }
];

export const HYDRONIC_AIR_HANDLER_CAPACITY_BTU = [
  {
    id: 1,
    label: '24,000',
    nominalValue: 24000,
    value: 24000
  },
  {
    id: 2,
    label: '36,000',
    nominalValue: 36000,
    value: 36000
  },
  {
    id: 3,
    label: '48,000',
    nominalValue: 48000,
    value: 48000
  },
  {
    id: 4,
    label: '60,000',
    nominalValue: 60000,
    value: 60000
  }
];

export const HYDRONIC_AIR_HANDLER_CAPACITY_KW = [
  {
    id: 1,
    label: 7.03,
    value: 7.03,
  },
  {
    id: 2,
    label: 10.55,
    value: 10.55,
  },
  {
    id: 3,
    label: 14.07,
    value: 14.07,
  },
  {
    id: 4,
    label: 17.58,
    value: 17.58,
  }
];

export const HP_CONVECTOR_CAPACITY_BTU = [
  {
    id: 1,
    label: '3,000',
    value: 3000
  },
  {
    id: 2,
    label: '5,000',
    value: 5000
  },
  {
    id: 3,
    label: '7,000',
    value: 7000
  }
];

export const HP_CONVECTOR_CAPACITY_KW = [
  {
    id: 1,
    label: 0.88,
    value: 0.88
  },
  {
    id: 2,
    label: 1.47,
    value: 1.47
  },
  {
    id: 3,
    label: 2.05,
    value: 2.05
  }
];

export const HP_CONVECTOR_TYPE = ['emitterType.highWall', 'emitterType.floorStanding'];

export const ACCESSORIES = [
  { accessoryTypeId: 1, accessoryName: 'UK2VK0', description: 'Motorized 2-way valve (FWXV)' },
  { accessoryTypeId: 2, accessoryName: 'UK3VK1', description: 'Motorized 3-way valve (FWXV)' },
  { accessoryTypeId: 3, accessoryName: 'UKT2VK0', description: 'Motorized 2-way valve (FWXT)' },
  { accessoryTypeId: 4, accessoryName: 'UKT3VK1', description: 'Motorized 3-way valve (FWXT)' },
  { accessoryTypeId: 5, accessoryName: 'EKDIST', description: 'Extension piece' },
  { accessoryTypeId: 6, accessoryName: 'EKEUR90', description: '90° elbow' },
  { accessoryTypeId: 7, accessoryName: 'EKDIST3W', description: 'Extension piece' }
];

export const PRODUCT_TYPE = {
  EMITTER: 'Emitter',
  TANK: 'Tank',
  THERMOSTAT: 'Thermostat',
  CONNECTION_KIT: 'Connection kit',
  ACCESSORY: 'Accessory',
  OUTDOOR_UNIT: 'Outdoor',
  INDOOR_UNIT: 'Indoor'
}

export const UNIT = {
  GAL: 'GAL',
  BTU: 'BTU/h',
  FAHRENHEIT: 'F',
  CELSIUS: 'C',
  KW: 'kW'
}

export const PIPE_CONNECTION = [
  { id: 'left', label: 'directions.left' },
  { id: 'right', label: 'directions.right' }
];

export const LANGUAGES = [
  { label: 'English', code: 'en' },
  { label: 'Spanish', code: 'es' },
  { label: 'French', code: 'fr' }
];

export const USER_PREFERENCE_TABS = [
  {
    id: 0,
    name: 'userPreferences.unitOfMeasures'
  },
  {
    id: 1,
    name: 'userPreferences.calculationParameters'
  },
  {
    id: 2,
    name: 'userPreferences.languages'
  }
];

export const LWT_RANGES_VALIDATION_CELSIUS = [
  {
    heatingMin: 25,
    heatingMax: 70,
    coolingMin: 7,
    coolingMax: 22
  }
];

export const LWT_RANGES_VALIDATION_FAHRENHEIT = [
  {
    heatingMin: 77,
    heatingMax: 158,
    coolingMin: 45,
    coolingMax: 72
  }
]

export const LWT_RANGES_VALIDATION_KW = [
  {
    requiredHeatingMin: 4,
    requiredHeatingMax: 15,
    requiredCoolingMin: 5,
    requiredCoolingMax: 12
  }
]

export const LWT_RANGES_VALIDATION_BTU = [
  {
    requiredHeatingMin: 13600,
    requiredHeatingMax: 51200,
    requiredCoolingMin: 17100,
    requiredCoolingMax: 41000
  }
]

export const GRAPH_LABEL = {
  TEMPERATURE: 'graph.outdoorTemperature',
  CAPACITY: 'graph.capacity',
  HP_CAPACITY: 'graph.hpCapacity',
  REQUIRED_CAPACITY: 'graph.requiredCapacity',
  BACKUP_HEATER_CAPACITY: 'graph.buhCapacity',
  SYSTEM_CAPACITY: 'graph.systemCapacity',
  EQUILIBRIUM_POINT: 'graph.equilibriumPoint'
}

export const GRAPH_MAX_CAPACITY = {
  BTU: 70000,
  KW: 20
}

export const GRAPH_INTERVAL = {
  BTU_INTERVAL: 10000,
  KW_INTERVAL: 2,
}

export const SYSTEM_TYPE = {
  HEATING: 'heating',
  COOLING: 'cooling'
} as const;

export const CALCULATION_PARAMETER_CELSIUS = {
  HEATING_MIN: 10,
  HEATING_MAX: 18,
  COOLING_MIN: 17,
  COOLING_MAX: 26

}

export const CALCULATION_PARAMETER_FAHRENHEIT = {
  HEATING_MIN: 50,
  HEATING_MAX: 64.4,
  COOLING_MIN: 62.6,
  COOLING_MAX: 78.8
}

export const NESTED_STEPPER = {
  APPLICATION_TYPE: 'applicationType',
  CONSTRUCTION_TYPE: 'constructionType',
  SYSTEM_DESIGN: 'systemDesign',
  EMITTER: 'emitter'
}

export const FILE_TYPE = {
  PDF: 'pdf',
  WORD: 'docx'
}